module.exports = __webpack_public_path__ + "static/media/BackMenu_AERO.6e4eee0f.svg";